import "core-js/modules/es.array.push.js";
import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import axios from "axios";
import moment from "moment";
// Import the plugin here
import VueApexCharts from "vue-apexcharts";
import { createPinia, PiniaVuePlugin } from "pinia";
import { Cognito } from "./cognito";
import * as Sentry from "@sentry/vue";
Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  environment: process.env.APP_ENV,
  integrations: [Sentry.vueIntegration({
    tracingOptions: {
      trackComponents: true,
      hooks: ["mount", "update", "unmount"]
    }
  }), Sentry.browserTracingIntegration({
    router
  }), Sentry.replayIntegration()],
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
});
// Install the authentication plugin here
Vue.use(Cognito, {
  region: process.env.VUE_APP_COGNITO_REGION,
  userPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,
  clientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
  identityPoolId: process.env.VUE_APP_COGNITO_IDENTITY_POOL_ID
});
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
const base = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  paramsSerializer: params => {
    const parts = [];
    for (const key in params) {
      const value = params[key];
      if (Array.isArray(value)) {
        value.forEach(v => parts.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(v)}`));
      } else if (value !== null && value !== undefined) {
        parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
      }
    }
    return parts.join("&");
  }
});
Vue.prototype.$http = base;
Vue.config.errorHandler = function (error) {
  if (error.name === "NavigationDuplicated") {
    return;
  }
};
moment.locale("ja");
Vue.prototype.$moment = moment;
Vue.use(VueApexCharts);
Vue.component("Apexchart", VueApexCharts);
Vue.use(PiniaVuePlugin);
const pinia = createPinia();
/* eslint-disable no-new */
new Vue({
  router,
  store,
  pinia,
  render: h => h(App)
}).$mount("#app");